//created by flemming
/**
 * used to reduce imports from other files
 */
export { default as LoginPage } from "./loginpage";
